// TODO: make this the main file when we move checkout to NextJS

import Button from "@ui-kit/form/Button/Button.web";
import Box from "@ui-kit/layout/Box/Box.web";
import Text from "@ui-kit/typography/Text/Text.web";
import Modal from "@ui-kit/overlays/Modal/Modal.web";
import CartSummary from "@app-contexts/public/features/basket/components/cart-summary/CartSummary/CartSummary.web";
import CheckoutLabel from "@ui-application/data-display/CheckoutLabel/CheckoutLabel.web";
import { usePublicBasket } from "@app-contexts/public/features/basket/services/usePublicBasket";
import { PUBLIC_ROUTES } from "@app-contexts/public/constants/public-routes";
import useRedirect from "@shared/hooks/useRedirect.web";
import { useTranslation } from "@shared/utils/internationalization";
import UserInteractionLogger from "@shared/lib/analytics/internal/UserInteractionLogger";
import { AnalyticsService } from "@shared/services/analytics";
import { useEffect, useRef } from "react";
import { CartSummaryModalProps } from "./CartSummaryModal.props";

export default function CartSummaryModal({
  venue = undefined,
  isOpen,
  onClose,
  holdLink = undefined,
  dynamicHoldParams = undefined,
}: CartSummaryModalProps) {
  const { t } = useTranslation("common");
  const { redirect } = useRedirect();
  const {
    hasItems,
    isBasketUpdating,
    totalItemQuantity,
    totalPrice,
    isWaitlist,
  } = usePublicBasket();
  const handleCheckout = (): void => {
    AnalyticsService.buttonClick({
      label: "initiate_checkout",
      custom_params: {
        source: "cart_summary",
        cart_version: "legacy",
        item_count: totalItemQuantity ?? 0,
        cart_total: totalPrice ?? 0,
      },
    });
    redirect(PUBLIC_ROUTES.CHECKOUT.ROOT);
  };
  const prevOpenRef = useRef(false);
  useEffect(() => {
    if (isOpen && !prevOpenRef.current) {
      prevOpenRef.current = true;
      UserInteractionLogger.buttonClick({
        label: "view_cart",
        custom_params: {
          cart_version: "legacy",
          item_count: totalItemQuantity ?? 0,
          cart_total: totalPrice ?? 0,
        },
      });
    }
    if (!isOpen) prevOpenRef.current = false;
  }, [isOpen, totalItemQuantity, totalPrice]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      size="4xl"
      scrollBehavior="inside"
    >
      <Modal.Header>{t("Cart summary")}</Modal.Header>

      <Modal.Body>
        <Box fontSize="md" minHeight="element.7xl">
          {hasItems ? (
            <CartSummary
              isDrawer
              venue={venue}
              holdLink={holdLink}
              onCartClose={onClose}
              dynamicHoldParams={dynamicHoldParams}
            />
          ) : (
            <Text>{t("There are no items in your cart")}</Text>
          )}
        </Box>
      </Modal.Body>

      <Modal.Footer>
        <Button
          data-testid="cart-summary-modal-checkout"
          ml="auto"
          variant="solid"
          colorPalette="primary"
          minHeight="element.3xl"
          minWidth="element.8xl"
          onClick={handleCheckout}
          isLoading={isBasketUpdating}
          disabled={!hasItems || isBasketUpdating}
        >
          <CheckoutLabel
            totalItemQuantity={totalItemQuantity}
            isWaitlist={isWaitlist}
          />
        </Button>
        <Button.Ghost
          data-testid="cart-summary-modal-cancel"
          onClick={onClose}
          textDecoration="underline"
        >
          {t("Cancel", { ns: "common" })}
        </Button.Ghost>
      </Modal.Footer>
    </Modal>
  );
}
